export default __webpack_public_path__ + "static/media/greetingBox.e139dba0.gif";